module.exports = "//static.hsappstatic.net/blog-editor-ui/static-1.11495/img/onboarding/guide.png"